import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AdminStats, User, Transaction, KycDocument } from '../../types';
import { adminService } from '../../services/admin';

interface AdminState {
  stats: AdminStats | null;
  users: User[];
  pendingDeposits: Transaction[];
  pendingWithdrawals: Transaction[];
  kycList: KycDocument[];
  loading: boolean;
}

const initialState: AdminState = {
  stats: null, users: [],
  pendingDeposits: [], pendingWithdrawals: [],
  kycList: [], loading: false,
};

export const fetchAdminDashboard = createAsyncThunk('admin/dashboard', async () => {
  const res = await adminService.getDashboard();
  return res.data;
});

export const fetchAdminUsers = createAsyncThunk('admin/users', async (params?: object) => {
  const res = await adminService.getUsers(params);
  return res.data;
});

export const fetchPendingDeposits = createAsyncThunk('admin/pendingDeposits', async () => {
  const res = await adminService.getPendingDeposits();
  return res.data;
});

export const fetchPendingWithdrawals = createAsyncThunk('admin/pendingWithdrawals', async () => {
  const res = await adminService.getPendingWithdrawals();
  return res.data;
});

export const fetchKycList = createAsyncThunk('admin/kycList', async (params?: object) => {
  const res = await adminService.getKycList(params);
  return res.data;
});

const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminDashboard.fulfilled, (s, a) => {
        s.stats = a.payload.stats;
      })
      .addCase(fetchAdminUsers.pending, (s) => { s.loading = true; })
      .addCase(fetchAdminUsers.fulfilled, (s, a) => {
        s.loading = false;
        s.users = a.payload.data || [];
      })
      .addCase(fetchPendingDeposits.fulfilled, (s, a) => {
        s.pendingDeposits = a.payload.data || [];
      })
      .addCase(fetchPendingWithdrawals.fulfilled, (s, a) => {
        s.pendingWithdrawals = a.payload.data || [];
      })
      .addCase(fetchKycList.fulfilled, (s, a) => {
        s.kycList = a.payload.data || [];
      });
  },
});

export default adminSlice.reducer;
